import {get} from 'lodash/fp';
import {createSelector} from 'reselect';

import {popover} from './root.selector';

export const isPopoverOpen = createSelector(popover, get('isPopoverOpen'));
